import { CATALOG, FREE, PRO, STUDIO, maxYearlySavingPct } from '../../lib/plans';
import { formatMoney } from '../../lib/format';

const m = (c: number) => formatMoney(c, CATALOG.currency);
const days = (h: number) => (h >= 48 ? `${h / 24} days` : `${h} hours`);

export const FAQ: { q: string; a: string }[] = [
  {
    q: 'Can I download YouTube videos?',
    a: 'No. Ayonix Studio works with YouTube for searching, filtering, saving and watching (through YouTube’s official embedded player), but YouTube doesn’t allow downloads in third-party apps, so download controls stay disabled for YouTube links.',
  },
  {
    q: 'What can I download?',
    a: 'Media you’re allowed to save: direct https:// links to audio or video files that permit browser downloads, and files from authorized providers such as Wikimedia Commons and Blender. Ayonix Studio inspects the source and offers only the resolutions it really publishes — nothing is upscaled. We never bypass DRM, logins or paywalls.',
  },
  {
    q: 'What is the difference between a browser download and a cloud download?',
    a: `A browser download streams the file straight from its source to your device (up to 500 MB, with pause and resume when the server supports it). A cloud download is fetched by our servers from an authorized provider and kept for you for a limited time (${days(FREE.limits.hosted_retention_hours)} on Free, ${days(PRO.limits.hosted_retention_hours)} on ${PRO.name}, ${days(STUDIO.limits.hosted_retention_hours)} on ${STUDIO.name}).`,
  },
  {
    q: 'How does AI transcription work?',
    a: 'You pick a file on your device. Your browser extracts the audio, converts it to 16 kHz mono and uploads it in short chunks, each transcribed by Whisper large-v3-turbo on Cloudflare Workers AI. Summaries are generated only from your transcript, and every point links to the timestamps it came from. Subtitles can be translated into 12 languages.',
  },
  {
    q: 'What do the paid plans cost?',
    a: `${PRO.name}: ${m(PRO.prices.month)} per month or ${m(PRO.prices.year)} per year. ${STUDIO.name}: ${m(STUDIO.prices.month)} per month or ${m(STUDIO.prices.year)} per year — yearly billing saves up to ${maxYearlySavingPct}%. Web payments are processed by Stripe. Cancel anytime in the Billing Portal and keep your plan until the end of the period you paid for.`,
  },
  {
    q: 'Can I get a refund?',
    a: 'Yes — contact support@ayonix.com. A full refund removes paid access immediately. Purchases made in the iOS app are refunded by Apple under App Store rules.',
  },
  {
    q: 'Which apps are available?',
    a: 'The web app is available now. macOS and Windows apps are offered as unsigned previews on the Desktop apps page once a build is published. The iPhone app is coming to the App Store; until then, use the web app on iPhone.',
  },
  {
    q: 'Can I export or delete my data?',
    a: 'Yes. From Account you can download all your data as JSON or permanently delete your account, which also cancels any Stripe subscription.',
  },
];
